import React, { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboard, MessageSquare, Heart, FileText, FileEdit, LogOut, ExternalLink, Droplets, Loader2 } from 'lucide-react';
import { adminCheck, clearToken, LOGO_URL } from '../../lib/api';

const items = [
  { to: '/admin', label: 'Tableau de bord', icon: LayoutDashboard, end: true },
  { to: '/admin/content', label: 'Contenu du site', icon: FileEdit },
  { to: '/admin/articles', label: 'Articles', icon: FileText },
  { to: '/admin/contacts', label: 'Messages', icon: MessageSquare },
  { to: '/admin/donations', label: 'Dons', icon: Heart },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    adminCheck().then(() => setReady(true)).catch(() => { clearToken(); navigate('/admin/login'); });
  }, [navigate]);

  const logout = () => { clearToken(); navigate('/admin/login'); };

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-sky-50">
        <Loader2 className="w-8 h-8 text-sky-500 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-sky-50/30 flex">
      <aside className="w-64 bg-white border-r border-sky-100 flex flex-col fixed inset-y-0 left-0">
        <div className="p-6 border-b border-sky-100">
          <Link to="/admin" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Logo" className="w-10 h-10 rounded-full shadow" />
            <div>
              <p className="font-display font-extrabold text-sky-950 leading-none">Kiosques</p>
              <p className="text-[10px] text-emerald-600 uppercase tracking-wider font-bold mt-1">Admin CMS</p>
            </div>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                  isActive ? 'bg-sky-50 text-sky-700' : 'text-slate-600 hover:bg-sky-50/60'
                }`
              }
            >
              <it.icon className="w-4 h-4" />
              {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-sky-100 space-y-1">
          <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium text-slate-600 hover:bg-sky-50">
            <ExternalLink className="w-4 h-4" />Voir le site
          </a>
          <button onClick={logout} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium text-rose-600 hover:bg-rose-50">
            <LogOut className="w-4 h-4" />Déconnexion
          </button>
        </div>
      </aside>
      <div className="flex-1 ml-64">
        <Outlet />
      </div>
    </div>
  );
}
